import React, { useEffect, useState } from 'react';
import './Joker.css';

const Joker = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isInApp, setIsInApp] = useState(false);
  const [inAppType, setInAppType] = useState('');
  const [debugInfo, setDebugInfo] = useState({});
  const [hasInviteCode, setHasInviteCode] = useState(false);
  const [inviteCode, setInviteCode] = useState('');
  const [hasDownloaded, setHasDownloaded] = useState(true);
  const [shouldShowLaunchButton, setShouldShowLaunchButton] = useState(false);

  useEffect(() => {
    // 检查URL是否包含www，如果不包含则跳转
    const checkAndRedirect = () => {
      const currentUrl = window.location.href;
      const urlObj = new URL(currentUrl);
      const urlParams = new URLSearchParams(window.location.search);
      const hasOpen = urlParams.has('open');
      
      // 如果URL中包含open=1参数，设置显示启动按钮
      if (urlParams.get('open') === '1') {
        setShouldShowLaunchButton(true);
      }
      
      // 检查是否需要添加www并重定向
      if (!urlObj.hostname.startsWith('www.') && urlObj.hostname !== 'localhost') {
        const newHostname = 'www.' + urlObj.hostname;
        urlObj.hostname = newHostname;
        
        // 如果没有open参数，添加open=1
        if (!hasOpen) {
          urlParams.append('open', '1');
          urlObj.search = urlParams.toString();
        }
        
        // 执行重定向
        window.location.href = urlObj.toString();
      }
    };
    
    // 执行URL检查
    checkAndRedirect();

    // 检测设备和内嵌浏览器
    const checkEnvironment = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // 设备类型检测
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const ios = /iPhone|iPad|iPod/i.test(userAgent);
      
      // 社交应用内嵌浏览器检测
      const inWechat = /MicroMessenger/i.test(userAgent);
      const inQQ = /QQ\//i.test(userAgent);
      const inWeibo = /Weibo/i.test(userAgent);
      const inTim = /TIM/i.test(userAgent);
      const inDingTalk = /DingTalk/i.test(userAgent);
      const inAlipay = /AlipayClient/i.test(userAgent);
      
      // 设置应用内打开状态
      const inAppBrowser = inWechat || inQQ || inWeibo || inTim || inDingTalk || inAlipay;
      setIsInApp(inAppBrowser);
      
      // 设置具体的应用类型
      let appType = '';
      if (inWechat) appType = '微信';
      else if (inQQ) appType = 'QQ';
      else if (inWeibo) appType = '微博';
      else if (inTim) appType = 'TIM';
      else if (inDingTalk) appType = '钉钉';
      else if (inAlipay) appType = '支付宝';
      
      setInAppType(appType);
      setIsMobile(mobile);
      setIsIOS(ios);
      
      // 更新调试信息
      setDebugInfo({
        userAgent,
        mobile,
        ios,
        inAppBrowser,
        appType,
        inWechat,
        inQQ,
        inWeibo,
        inTim,
        inDingTalk,
        inAlipay
      });
    };
    
    // 检测环境
    checkEnvironment();
    
    // 检查URL中是否有邀请码
    const checkInviteCode = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const inviteParam = urlParams.get('invite');
      if (inviteParam) {
        setHasInviteCode(true);
        setInviteCode(inviteParam);
      }
    };
    
    checkInviteCode();
    
  }, []);

  // 处理下载按钮点击事件
  const handleButtonClick = () => {
    if (isMobile) {
      // 下载应用
      if (isIOS) {
        // iOS AppStore下载链接 - 在新标签页打开
        window.open('https://apps.apple.com/cn/app/id6723865885', '_blank');
      } else {
        // 安卓 TapTap下载链接 - 在新标签页打开
        window.open('https://l.taptap.cn/UpieP9lr?channel=rep-rep_dl584c8qqje', '_blank');
      }
      // 设置已下载状态
      setHasDownloaded(true);
    } else {
      // PC端下载逻辑，可以直接导向官网或下载页 - 在新标签页打开
      window.open('https://l.taptap.cn/UpieP9lr?channel=rep-rep_dl584c8qqje', '_blank');
    }
  };

  // 生成Universal Link URL
  const generateLaunchUrl = () => {
    // 确保Android和iOS都能正常打开的链接
    if (isIOS) {
      // iOS使用Universal Link
      let launchUrl = 'https://iyztp.com/joker';
      
      // 如果有邀请码，添加到启动URL中
      if (hasInviteCode) {
        launchUrl += `?invite=${inviteCode}`;
      }
      
      return launchUrl;
    } else {
      // Android使用intent格式
      let baseUrl = 'https://iyztp.com/joker';
      
      // 如果有邀请码，添加到启动URL中
      if (hasInviteCode) {
        baseUrl += `?invite=${inviteCode}`;
      }
      
      // 使用intent格式，确保能够正确处理Android
      return `intent://${baseUrl.replace('https://', '')}#Intent;scheme=https;package=com.tousan.joker;S.browser_fallback_url=${encodeURIComponent(baseUrl)};end`;
    }
  };

  return (
    <div className="joker-simple-container">
      <div className="joker-simple-content">
        {isInApp && (
          <div className="app-guide" style={{
            position: 'fixed',
            top: 0,
            right: 0,
            padding: '20px',
            zIndex: 100,
            textAlign: 'right'
          }}>
            <img 
              src={require('../img/arrow_guide.png')} 
              alt="点击右上角在浏览器中打开" 
              style={{
                width: '50px',
                height: 'auto',
                marginBottom: '5px'
              }}
            />
            <p style={{
              color: 'white',
              fontSize: '14px',
              margin: 0,
              fontWeight: 'bold',
              textShadow: '0 0 4px #000, 0 0 2px #000, 1px 1px 2px #000, -1px -1px 2px #000'
            }}>
              点击右上角<br />在浏览器中打开
            </p>
          </div>
        )}
        
        <div className="joker-image-container">
          <img src={require('../img/bg_joker.png')} alt="" className="joker-image" />
        </div>
        
        <div className="joker-button-container">
          <h2 className="joker-button-title">小丑牌 - 符号狂潮</h2>
          <p className="joker-button-description">
            0加载时间，打开即玩的肉鸽卡牌游戏
          </p>
          
          {/* 邀请奖励提示信息 */}
          {hasInviteCode && isMobile && (
            <div style={{
              backgroundColor: 'rgba(255, 215, 0, 0.2)',
              border: '1px solid gold',
              borderRadius: '5px',
              padding: '10px',
              marginBottom: '15px',
              color: 'white',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, fontSize: '12px' }}>
                通过本页面打开游戏可获得<br/>
                <span style={{ fontSize: '20px', display: 'block', marginTop: '5px' }}>
                  🎉 派对卡包
                </span>
              </p>
            </div>
          )}
          
          {!isInApp && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '100%' }}>
              <button 
                onClick={handleButtonClick} 
                className="joker-button"
                style={{
                  padding: '12px 20px',  // 减小高度
                  width: '48%',          // 增加宽度
                  maxWidth: '400px'      // 增加最大宽度
                }}
              >
                {'下载游戏'}
              </button>
              
              {/* 移动设备上显示"启动游戏"按钮 - 使用a标签 */}
              {(shouldShowLaunchButton || (isMobile && (hasDownloaded || localStorage.getItem('hasDownloadedJoker')))) && (
                <a 
                  href={generateLaunchUrl()}
                  className="joker-button"
                  style={{
                    backgroundColor: '#4CAF50',
                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    textDecoration: 'none',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '12px 20px',  // 减小高度
                    width: '48%',          // 增加宽度
                    maxWidth: '400px'      // 增加最大宽度
                  }}
                >
                  启动游戏
                </a>
              )}  
            </div>
          )}
          
          <p className="joker-button-footer">
            {isMobile 
              ? (isIOS 
                ? "适用于iOS 14.0及以上版本" 
                : "适用于Android 7.0及以上版本")
              : "支持iOS和Android系统"}
          </p>
          
          {/* 调试信息区域 - 使用白色文本 */}
          {/* <div className="debug-info" style={{ marginTop: '20px', textAlign: 'left', fontSize: '12px', color: 'white' }}>
            <h3>调试信息：</h3>
            <p>是否在应用内打开：{isInApp ? `是 (${inAppType})` : '否'}</p>
            <p>设备类型：{isMobile ? (isIOS ? 'iOS移动设备' : 'Android移动设备') : 'PC设备'}</p>
            <details>
              <summary>详细信息</summary>
              <pre style={{ color: 'white' }}>{JSON.stringify(debugInfo, null, 2)}</pre>
            </details>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Joker; 
